module.exports = __webpack_public_path__ + "static/media/Proyecto-2020.9fc7ea64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Proyecto-2020.jpg
// module id = 516
// module chunks = 0